import axiosClient from "./axios-client";

export const getStats = async () => {
  const response = await axiosClient.get("/stats");
  return response.data;
};
